import React from "react";

export interface CardDataDetailsProps {
    title: string;
    img: string;
    description: string;
    isCustom?: boolean;
    isArabic?: boolean;
    cardBodyColor?: string;
    titleColor?: string;
}

const CardDataDetails: React.FC<CardDataDetailsProps> = (props) => {
    const { description, img, title, isCustom, isArabic, cardBodyColor, titleColor } = props;
    return (
        <div style={{ border: "1px solid #EAECF0", borderRadius: "12px", background: isArabic ? cardBodyColor : "initial" }} className="card-carousal-card overflow-hidden">
            <img src={img} style={{ width: "auto", objectFit: "cover" }} alt="cardDataCarousal" />
            <div className="flex flex-col justify-center items-start py-2 space-y-4 px-2">
                <p
                    className={`text-xl font-bold text-gray-900 w-full ${isCustom ? "text-center" : isArabic ? "text-right" : "text-start"}`}
                    style={{ color: isArabic ? titleColor : undefined }}
                >
                    {title}
                </p>
                <p
                    className={`text-sm text-gray-500 font-normal w-full ${isCustom ? "text-center px-2" : isArabic ? "text-right" : "text-start"}`}
                    style={{ color: isArabic ? titleColor : undefined }}
                >
                    {description}
                </p>
            </div>
        </div>
    );
};

export default CardDataDetails;
